export const worklistKeys = {
    all: ["worklist"] as const,
    forms: (userIds: string[] = []) => [...worklistKeys.all, "forms", ...userIds.toSorted()] as const,
    incompleteData: (userIds: string[] = []) =>
        [...worklistKeys.all, "incomplete-data", ...userIds.toSorted()] as const,
    consents: (userIds: string[] = []) => [...worklistKeys.all, "consents", ...userIds.toSorted()] as const,
    dismissals: () => [...worklistKeys.all, "dismissals"] as const,
    counts: () => [...worklistKeys.all, "counts"] as const,
};
